import jsPDF from "jspdf";
import "jspdf-autotable";
import { OrderDetails } from "../types/types";

const safeNumber = (value: any): number => (isNaN(Number(value))) ? 0 : Number(value);


export const generateInvoicePdf = (
  orderDetails: OrderDetails,
  payments: any[],
  id: string
) => {
  const doc = new jsPDF();
  const logoUrl = "https://a.nationtonation.ca/ggg.png";

  fetch(logoUrl)
    .then((res) => res.blob())
    .then((blob) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result as string;

        // 🖼️ Logo
        doc.addImage(base64, "PNG", 10, 12, 30, 30);

        // 📣 Business Message
        const textX = 50;
        const textY = 24;

        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text("Please review numbers carefully as mistakes can be made", textX, textY);
        doc.setFont("helvetica", "italic");
        doc.text("Thank you for your continued business.", textX, textY + 7);

        // ─────────────────────────────────────────────
        // 🧾 Header
        doc.setDrawColor(0);
        doc.setLineWidth(1);
        doc.line(10, 45, 200, 45);

        doc.setFontSize(18);
        doc.setFont("helvetica", "bold");
        doc.text("Invoice", 10, 55);

        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");
        doc.text(`Order #${id}`, 10, 65);

        // ─────────────────────────────────────────────
        // 👤 Customer Info
        doc.setDrawColor(200);
        doc.setLineWidth(0.5);
        doc.rect(10, 70, 190, 40);

        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text("Customer Details", 15, 75);

        doc.setFont("helvetica", "normal");
        doc.text(`Name: ${orderDetails.customer_name || "N/A"}`, 15, 85);
        doc.text(`Email: ${orderDetails.customer_email || "N/A"}`, 15, 90);
        doc.text(`Dispensary: ${orderDetails.customer_dispensary_name || "N/A"}`, 15, 95);
        doc.text(`Shipping Address: ${orderDetails.shipping_address || "N/A"}`, 15, 100);

        // ─────────────────────────────────────────────
        // 🛒 Order Items Table
        const items = (orderDetails.items || orderDetails.line_items || []).map((item) => [
          item.product_name,
          item.variant_name || "N/A",
          item.quantity,
          `$${safeNumber(item.price).toFixed(2)}`,
          `$${(safeNumber(item.quantity) * safeNumber(item.price)).toFixed(2)}`,
        ]);

        doc.autoTable({
          head: [["Product Name", "Variant", "Quantity", "Unit Price", "Total"]],
          body: items,
          startY: 115,
          theme: "grid",
          styles: { fontSize: 10, cellPadding: 2 },
          headStyles: { fillColor: [220, 220, 220], textColor: 0 },
        });

        // ─────────────────────────────────────────────
        // 💲 Summary
        const tableY = (doc as any).lastAutoTable.finalY + 10;
        doc.setFont("helvetica", "bold");
        doc.text(`Subtotal: $${safeNumber(orderDetails.total).toFixed(2)}`, 15, tableY);
        doc.text(
          `Outstanding Balance: $${safeNumber(orderDetails.outstanding_balance).toFixed(2)}`,
          15,
          tableY + 10
        );

        let nextSectionY = tableY + 20;

        // 📝 Order Notes
        if (orderDetails.note) {
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text("Order Notes", 15, nextSectionY);
          doc.setDrawColor(180);
          doc.setFillColor(245, 245, 245);
          doc.roundedRect(15, nextSectionY + 5, 180, 20, 3, 3, "F");
          doc.setFont("helvetica", "normal");
          doc.setTextColor(50);
          doc.text(orderDetails.note, 20, nextSectionY + 15, { maxWidth: 170 });
          nextSectionY += 35;
        }

        // 💳 Payment Info
        if (payments.length > 0) {
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text("Payment Details", 15, nextSectionY);

          const paymentDetails = payments.map((payment) => [
            new Date(payment.payment_date).toLocaleDateString(),
            `$${safeNumber(payment.amount).toFixed(2)}`,
            payment.method,
            payment.status,
          ]);

          doc.autoTable({
            head: [["Date", "Amount", "Method", "Status"]],
            body: paymentDetails,
            startY: nextSectionY + 5,
            theme: "grid",
            styles: { fontSize: 10, cellPadding: 2 },
          });

          const paymentTableY = (doc as any).lastAutoTable.finalY + 10;
          doc.setFont("helvetica", "bold");
          doc.text(
            `Total Payments: $${payments.reduce((sum, p) => sum + safeNumber(p.amount), 0).toFixed(2)}`,
            15,
            paymentTableY
          );
          nextSectionY = paymentTableY + 10;
        } else {
          doc.setFont("helvetica", "normal");
          doc.text("No payments made yet.", 15, nextSectionY);
          nextSectionY += 15;
        }
        // 📎 Footer Line
        doc.setDrawColor(0);
        doc.setLineWidth(1);
        const pageHeight = doc.internal.pageSize.height;
        doc.line(10, pageHeight - 20, 200, pageHeight - 20);

        // 💾 Save it
        doc.save(`Order_${id}_Invoice.pdf`);
      };
      reader.readAsDataURL(blob);
    });
};
